export const LANG_CN_NAME = 'cn';

export let LANG_CN_TRANS = { 
    'Report & Analysis': '报告与分析',
    'Profile': '轮廓',
    'EFFICIENCY': '效率',
    'Customer' : '顾客'
};